import gql from "graphql-tag"

import MarketingProfileSettings from "../fragments/marketingProfileSettings"

const query = gql`
  query GetMarketingProfileSettings($userId: ID!) {
    marketingProfileSettings(userId: $userId) {
      ...MarketingProfileSettings
    }
  }
  ${MarketingProfileSettings}
`

export default query
